import { useCallback, useEffect, useState } from 'react';
import { AdminNotification, notificationService } from '../services/notification.service';

interface UseAdminNotificationsResult {
  notifications: AdminNotification[];
  loading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

export const useAdminNotifications = (): UseAdminNotificationsResult => {
  const [notifications, setNotifications] = useState<AdminNotification[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchNotifications = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await notificationService.getLatest(5);
      setNotifications(data);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Không thể tải thông báo'));
      setNotifications([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  return {
    notifications,
    loading,
    error,
    refetch: fetchNotifications,
  };
};

export default useAdminNotifications;